export enum RuntimeTextSelection{
    NotPublished,
    InactiveWithSubscriptionInFuture,
    InactiveWithNoSubscriptionInFuture,
    InactiveWithNoSubscriptionInPast,
    ActiveWithNoSubscriptionInPast,
    NeverActive
}
